<template>
  <div class="select">
    <select v-model="model" :aria-labelledby="label" class="select__input">
      <slot></slot>
    </select>
    <Caret />
  </div>
</template>
<script setup>
  import Caret from '@/components/icons/Caret.vue'

  const props = defineProps({
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  })

  const model = defineModel()
</script>

<style lang="scss" scoped>
  .select {
    position: relative;

    .icon {
      position: absolute;
      right: $spacer05;
      top: 0.8rem;
      height: 1.2em;
      width: 1em;
      pointer-events: none;
      transform: rotate(90deg);
    }
  }

  .select__input {
    width: 100%;
    height: 2.5rem;
    appearance: none;
    border: 0;
    color: inherit;
    border-bottom: 2px solid $grey-dark;
    background-color: transparent;
    padding: 0;
  }
</style>
